export const FileSystemEndpoints={
    video:'/v3/file/video'
}